import { jsxs as z, jsx as i } from "react/jsx-runtime";
import { useMemo as S } from "react";
import { _ as e } from "../../cs-Dfox81s-.js";
import "../../type-Dku6Xzl6.js";
import p from "../../hooks/useSpacingToken.js";
import { gapSpacings as f, fullSpacings as D } from "../../utils/style.js";
import '../../index29.css';const L = "_inline-layout_ycr83_1", O = "_start-aligned-content_ycr83_5", x = "_end-aligned-content_ycr83_9", P = "_after-content_ycr83_13", j = "_before-content_ycr83_14", M = "_children_ycr83_52", k = "_ellipsized_ycr83_57", E = "_with-inline-display_ycr83_65", n = {
  inlineLayout: L,
  startAlignedContent: O,
  endAlignedContent: x,
  afterContent: P,
  beforeContent: j,
  children: M,
  ellipsized: k,
  withInlineDisplay: E
};
function H(m) {
  const {
    className: _,
    elementRef: C,
    before: o,
    beforeContainerClassName: g,
    children: h,
    childrenContainerClassName: y,
    after: s,
    afterContainerClassName: u,
    spacing: a,
    spacingOffset: r,
    withPadding: l,
    withoutSpacingOpticalCorrection: c,
    withAdditionalInlinePadding: w,
    withEllipsizedContent: N,
    contentAlignment: d = "center",
    withInlineDisplay: A,
    ...b
  } = m, I = S(() => l ? D : f, [l]), v = p({
    spacing: a,
    modes: I,
    offset: r ?? 0,
    withAdditionalInlinePadding: w,
    withoutOpticalCorrection: c
  }), t = p({
    spacing: a,
    modes: f,
    offset: r ?? 0,
    withoutOpticalCorrection: c
  });
  return /* @__PURE__ */ z(
    "div",
    {
      ...b,
      ref: C,
      className: e(
        n.inlineLayout,
        v,
        d === "start" && n.startAlignedContent,
        d === "end" && n.endAlignedContent,
        A && n.withInlineDisplay,
        _
      ),
      children: [
        o && /* @__PURE__ */ i(
          "div",
          {
            className: e(
              n.beforeContent,
              t,
              g
            ),
            children: o
          }
        ),
        /* @__PURE__ */ i(
          "div",
          {
            className: e(
              n.children,
              t,
              y,
              N && n.ellipsized
            ),
            children: h
          }
        ),
        s && /* @__PURE__ */ i(
          "div",
          {
            className: e(
              n.afterContent,
              u,
              t
            ),
            children: s
          }
        )
      ]
    }
  );
}
export {
  H as default
};
